<style scoped>
    .list {
        height: 32px;
        background-color: #fafafa;
        border: 1px solid #fafafa;
        margin-bottom: 10px;
        border-radius: 4px;
        padding: 0 8px;
    }

    .list_editing {
        margin-bottom: 10px;
    }
</style>
<template>
    <div>
        <div v-if="options.editable!==false">
            <div v-for="(item,index) in current" :key="index">
                <div v-if="editIndex==index" class="list_editing">
                    <Input :ref="`input_${index}`" v-model="current[index]" style="width: 260px;" suffix="ios-return-left" @on-enter="saveItem(item,index)" @on-blur="saveItem(item,index)" :placeholder="options.placeholder||''"></Input>
                </div>
                <div class="list jcsb" v-else>
                    <div style="width: 200px;" class="nowrap" @click="toEdit(index)">{{item}}</div>
                    <div @click.stop="removeItem(index)">
                        <Icon type="ios-remove-circle" style="color: #20bf64;"></Icon>
                    </div>
                </div>
            </div>
            <Input v-if="!options.max || current.length < options.max" ref="input" v-model="form.value" style="width: 260px;" suffix="ios-add" @on-enter="addItem" :placeholder="options.placeholder||''">
            </Input>
        </div>
        <div v-else>
            <div class="list" v-for="(item,index) in current" :key="index">
                {{item}}
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            options: {
                type: Object,
                default: {},
            },
            current: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                loading: false,
                form: { value: '' },
                editIndex: -1,
            }
        },
        mounted() {},
        methods: {
            addItem() {
                if (!this.form.value) return
                this.current.push(this.form.value)
                this.form.value = ''
            },
            removeItem(index) {
                this.current.splice(index, 1)
                this.editIndex = -1
            },
            toEdit(index) {
                this.editIndex = index
                setTimeout(() => {
                    this.$refs['input_' + index][0].focus({ cursor: 'all' })
                }, 100)
            },
            saveItem(item, index) {
                if (item === '') {
                    this.removeItem(index)
                }
                this.editIndex = -1
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/common/TextList.vue?6fd0507f